export const StepMsgApi = 'supply/message/stepmsg' // 步骤信息 
export const MsgApi = 'wx/shopmarketmsg/' // 会员与店铺的消息信息